import React, { Fragment, useEffect, useState, forwardRef, ReactElement, Ref } from "react";
import { styled } from '@mui/material/styles';
import { Typography, Box, Divider, Step, StepLabel, Stepper, Stack, Alert, CircularProgress, Container, Link } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Button, { ButtonProps } from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import 'src/assets/css/custom.css';
import FormTwo from "./FormTwo";
import Final from "./Final";
import PrintIcon from '@mui/icons-material/Print';
import http, { ROUTES } from "src/utils/httpHelper";
import Grid from '@mui/material/Grid'; // Grid version 1
import { useNavigate } from "react-router-dom";
import Block1 from 'src/components/StepperHighschool/Texts/Block1';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import html2canvas from 'html2canvas';
import ReactGA from 'react-ga';
import { TransitionProps } from '@mui/material/transitions';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, Slide, Avatar, IconButton, Collapse } from "@mui/material";
import { useTranslation } from "react-i18next";


const Transition = forwardRef(function Transition(
  props: TransitionProps & { children: ReactElement<any, any> },
  ref: Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const DialogWrapper = styled(Dialog)(
  () => `
      .MuiDialog-paper {
        overflow: visible;
      }
`
);

const AvatarUnsuccess = styled(Avatar)(
  ({ theme }) => `
      background-color: ${theme.colors.error.main};
      color: ${theme.palette.error.contrastText};
      width: ${theme.spacing(12)};
      height: ${theme.spacing(12)};
      box-shadow: ${theme.colors.shadows.error};
      top: -${theme.spacing(6)};
      position: absolute;
      left: 50%;
      margin-left: -${theme.spacing(6)};

      .MuiSvgIcon-root {
        font-size: ${theme.typography.pxToRem(45)};
      }
`
);

function getSteps() {
  return ["1", "2"];
}

function getStepContent(control, generalDataController, step) {
  switch (step) {
    case 0:
      ReactGA.event({
        category: 'Appointment',
        action: 'Informacion_Personal'
      });
      return <FormTwo control={control} generalDataController={generalDataController} />;
    case 1:
      ReactGA.event({
        category: 'Appointment',
        action: 'Contacto'
      });
      return <Final control={control} generalDataController={generalDataController} />;
    default:
      return "Unknown step";
  }
}

export default function Main(props) {
  ReactGA.initialize('G-R3RK5N240R');
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();
  const [isPrinting, setIsPrinting] = useState(false);
  const [appointment, setAppointment] = useState(null);
  const [isTutorAppointment, setTutorAppointment] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [appointmentTutorDate, setAppointmentTutorDate] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(true);
  const { t } = useTranslation();
  const [moduleText, setModuleText] = useState(null);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const next = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  }

  const handleNext = async () => {
    switch (activeStep) {
      case 0:
        let stepTwoRequiredPassed = await props.generalDataController.trigger([
          'licences_year_id',
          'curp',
          'name',
          'last_name',
          'second_last_name',
          'sex',
          'rfc',
          'birthdate',
          'marital_status',
          'nationality_id',
          'phone',
          'email',
          'occupation',
          'social_media',
          'social_username'
        ]);

        if (!stepTwoRequiredPassed) {
          return;
        }

        if (props.generalDataController.age >= 16) {
          if (props.generalDataController.getValues('licence_type_id') == 6 || props.generalDataController.getValues('licence_type_id') == 7) {
            if (props.generalDataController.age >= 18) {
              props.generalDataController.enqueueSnackbar(
                "Favor de seleccionar la licencia correcta, se seleccionó menor de edad",
                { variant: 'error' });
              return;
            }
          } else {
            if (props.generalDataController.age < 18) {
              props.generalDataController.enqueueSnackbar(
                "Favor de seleccionar la licencia correcta, se seleccionó mayor de edad",
                { variant: 'error' });
              return;
            }
          }
        } else {
          props.generalDataController.enqueueSnackbar(
            "Los menores de 16 años no pueden trámitar licencias",
            { variant: 'error' });
          return;
        }

        next();
        break;
      case 1:
        const isMinorLicence = props.generalDataController.getValues('licence_type_id') == 6 || props.generalDataController.getValues('licence_type_id') == 7;

        let finalFieldsToValidate = [
          'prefix',
          'street',
          'ext_number',
          'postal_code',
          'postal_code_id',
          'state_id',
          'municipality_id',
          'neighborhood_id',
          'contact_name',
          'contact_last_name',
          'contact_second_last_name',
          'contact_phone'
        ];

        if (isMinorLicence) {
          finalFieldsToValidate = finalFieldsToValidate.concat([
            'tutor_curp',
            'tutor_name',
            'tutor_last_name',
            'tutor_second_last_name',
            'tutor_phone',
            'tutor_email',
            'tutor_sex',
            'tutor_rfc',
            'tutor_marital_status',
            'tutor_occupation',
            'tutor_nationality_id',
            'tutor_prefix',
            'tutor_street',
            'tutor_ext_number',
            'tutor_postal_code',
            'tutor_postal_code_id',
            'tutor_state_id',
            'tutor_municipality_id',
            'tutor_neighborhood_id'
          ]);
        }

        const finalStepValid = await props.generalDataController.trigger(finalFieldsToValidate);

        if (!finalStepValid) {
          props.generalDataController.enqueueSnackbar(
            'Por favor completa todos los campos requeridos del formulario.',
            { variant: 'error' }
          );
          return;
        }

        if (isMinorLicence) {
          if (props.generalDataController.tutorAge < 18) {
            props.generalDataController.enqueueSnackbar(
              'Los menores de 18 años no pueden ser tutores',
              { variant: 'error' }
            );
            return;
          }
        }

        let formData = props.generalDataController.getValues();
        setIsLoading(true);
        http.post(ROUTES.HG_APPOINTMENT, formData)
          .then((response: any) => {
            handleModule(1);
            const appointment = response.data.appointment;
            setAppointment(appointment);
            if ((props.generalDataController.getValues('licence_type_id') == 6 || props.generalDataController.getValues('licence_type_id') == 7)) {
              const tutor = response.data.tutor_appointment;
              setTutorAppointment(tutor);
            }
            localStorage.clear();

            next();
            ReactGA.event({
              category: 'Appointment',
              action: 'Resumen'
            });
          })
          .catch(error => {
            if (error.message === "Duplicated appointment") {
              handleOpenDialog();
            } else {
              props.generalDataController.enqueueSnackbar(
          error.message != '' ? error.message :
            'Hubo un error al generar la cita.\n' + error.exception,
          { variant: 'error' });
            }
          })
          .finally(() => {
            setIsLoading(false);
          })
        break;

      default:
        break;
    }
  };

  const handleBack = () => {
    if (activeStep == 0) {
      navigate("/highschool");
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const print = () => {
    setIsPrinting(true);
  }

  useEffect(() => {
    if (isPrinting) {
      const input = document.getElementById('divToPrint');
      const hiddenImage = document.getElementById('hiddenImage') as HTMLImageElement;
      html2canvas(input, { scale: 1.1 })
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          hiddenImage.src = imgData;
        })
        .then(() => {
          window.print();
        })
        .finally(() => {
          setIsPrinting(false);
        });
    }
  }, [isPrinting])

  const handleModule = (module) => {
    switch (module) {
      case 1:
        if(props.generalDataController.getValues('formality_name') == 'Primera vez'){
          setModuleText('Cd. Chihuahua: 614 429 3300 Ext. 20963 y 20964  <br/>')
        }else{
          setModuleText('Cd. Chihuahua: 614 429 3300 Ext. 20511.  <br/>')
        }
        break;
      case 2:
      case 3:
        if(props.generalDataController.getValues('formality_name') == 'Primera vez'){
          setModuleText('Cd. Juárez: 656 629 3300 Ext. 55254. <br/>')
        }else{
          setModuleText('Cd. Juárez: 656 629 3300 Ext. 55254. <br/>')
        }
        break;
      default:
        setModuleText('Cd. Chihuahua: 614 429 3300 Ext. 20511. <br/> Cd. Juárez: 656 629 3300 Ext. 55254. <br/> Licencia por primera vez: <br/> Cd. Chihuahua: 614 429 3300 Ext. 20742. <br/> Cd. Juárez: 656 629 3300 Ext. 55254. <br/>')
        break;
    }
  } 

  return (
    <>
      <style>
        {`
          @media print {
            #hiddenDiv {
              display: block !important;
            }
            #divToHide, #logo-bar {
              display: none;
            }
          }
        `}
      </style>
      <div>
        <div id="hiddenDiv" className=".print-image" style={{ display: 'none', width: '100%' }}>
          <img id="hiddenImage" src="" style={{ width: '100%' }} />
        </div>
        <Stepper activeStep={activeStep}>
          {steps.map((label) => {
            const stepProps = {};
            const labelProps = {};

            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div id="divToHide">
          {activeStep === steps.length ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Stack id="divToPrint" style={{ width: "70%", alignItems: "center", display: "flex" }} sx={{ mt: 2 }} spacing={2}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <Alert iconMapping={{ success: <CheckCircleOutlineIcon sx={{ fontSize: "50px" }} />, }} >
                      <Typography variant="h2" sx={{ lineHeight: "unset" }}>¡Listo! Tu cita ha quedado agendada</Typography>
                    </Alert>
                  </CardContent>
                </Card>

                <Card sx={{ minWidth: 275, maxWidth: '70%' }}>
                  <CardContent>
                    <Grid container>
                      <Grid item xs={12} md={12} lg={12}>
                        <Typography variant="overline" display="block" gutterBottom>
                          Nombre del solicitante:
                        </Typography>
                        {
                          props.generalDataController.getValues('name') + ' ' +
                          props.generalDataController.getValues('last_name') + ' ' +
                          props.generalDataController.getValues('second_last_name')
                        }
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="overline" display="block" gutterBottom>
                          Folio:
                        </Typography>
                        {appointment.id}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="overline" display="block" gutterBottom>
                          Cita: 
                        </Typography>
                        {appointment.date} {appointment.time}hrs
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="overline" display="block" gutterBottom>
                          Tipo de trámite: 
                        </Typography>
                        Primera vez
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="overline" display="block" gutterBottom>
                          Módulo: 
                        </Typography>
                        Chihuahua
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="overline" display="block" gutterBottom>
                          Tipo de licencia:
                        </Typography>
                        {props.generalDataController.selectsData.licenceTypes.find(licenceType => licenceType.id == props.generalDataController.getValues('licence_type_id'))?.name}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="overline" display="block" gutterBottom>
                          Dirección:
                        </Typography>
                            {'Feria de servicios Los Naranjos'}
                     </Grid>
                    </Grid>
                    {
                      (props.generalDataController.getValues('licence_type_id') == 6 || props.generalDataController.getValues('licence_type_id') == 7) &&
                      <Fragment>
                        <Divider style={{ marginTop: 10, marginBottom: 10 }}></Divider>
                        <Grid container>
                          <Grid item xs={12} md={8}>
                            <Typography variant="overline" display="block" gutterBottom>
                              Nombre del tutor del solicitante:
                            </Typography>
                            {
                              props.generalDataController.getValues('tutor_name') + ' ' +
                              props.generalDataController.getValues('tutor_last_name') + ' ' +
                              props.generalDataController.getValues('tutor_second_last_name')
                            }
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography variant="overline" display="block" gutterBottom>
                              Folio:
                            </Typography>
                              {isTutorAppointment.id}
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography variant="overline" display="block" gutterBottom>
                              Tipo de trámite:
                            </Typography>
                              Plática para tutores
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography variant="overline" display="block" gutterBottom>
                              Cita: 
                            </Typography>
                            {appointment.date} {appointment.time}hrs
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography variant="overline" display="block" gutterBottom>
                              Módulo:
                            </Typography>
                            Chihuahua
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <Typography variant="overline" display="block" gutterBottom>
                              Dirección:
                            </Typography>
                            {'Feria de servicios Los Naranjos'}
  
                          </Grid>
                        </Grid>
                      </Fragment>
                    }
                    {(!isPrinting) && <Fragment>
                      <Button
                        variant="outlined"
                        startIcon={<PrintIcon />}
                        endIcon={<PictureAsPdfIcon />}
                        fullWidth
                        sx={{ mt: 2 }}
                        onClick={print}
                      >
                        Imprimir /  Exportar PDF
                      </Button>
                    </Fragment>}
                  </CardContent>
                </Card>
                <Container><Block1 /></Container>
                {(!isPrinting) && <Button href="/highschool">Volver al inicio</Button>}
              </Stack>
            </div>
          ) : (
            <div>
              <Typography>
                {getStepContent(props.control, props.generalDataController, activeStep)}
              </Typography>

              <Divider sx={{ mt: 2, mb: 2 }}></Divider>

              <Box>
                <Button
                  onClick={handleBack}
                  color="secondary"
                  variant="outlined"
                >
                  <ChevronLeftIcon />
                  Regresar
                </Button>

                <Button
                  variant="contained"
                  onClick={handleNext}
                  style={{ float: "right" }}
                  disabled={isLoading}
                  startIcon={
                    isLoading ? <CircularProgress size="1rem" /> : null
                  }
                >
                  {activeStep === steps.length - 1 ? "Terminar" : "Siguiente"}
                  <ChevronRightIcon />
                </Button>
              </Box>
            </div>
          )}
        </div>
      </div>

      <DialogWrapper
        open={openDialog}
        maxWidth="sm"
        fullWidth
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDialog}
      >
        <Box
          sx={{
            px: 4,
            pb: 4,
            pt: 10
          }}
        >
          <AvatarUnsuccess>
            <ErrorOutlineOutlinedIcon />
          </AvatarUnsuccess>

          <Collapse in={openAlert}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenAlert(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="info"
            >
              <Typography variant="body1" component="div">
                {t('DUPLICATED-APPOINTMENT.INFO')}
                <br />
                <br />
                {t('DUPLICATED-APPOINTMENT.CONTACT_DATA_RENOVATION')}
                <br />
                {t('DUPLICATED-APPOINTMENT.CONTACT_DATA_RENOVATION_CH')}
                <br />
                {t('DUPLICATED-APPOINTMENT.CONTACT_DATA_RENOVATION_JU')}
                <br />
                <br />
                {t('DUPLICATED-APPOINTMENT.CONTACT_DATA_FIRSTIME')}
                <br />
                {t('DUPLICATED-APPOINTMENT.CONTACT_DATA_FIRSTIME_CH')}
                <br />
                {t('DUPLICATED-APPOINTMENT.CONTACT_DATA_FIRSTIME_JU')}
              </Typography>
            </Alert>
          </Collapse>
          <Typography
            align="center"
            sx={{
              py: 4,
              px: 10
            }}
            variant="h3"
          >
            {t('DUPLICATED-APPOINTMENT.TITLE')}
          </Typography>

          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={handleCloseDialog}
          >
            {t('DUPLICATED-APPOINTMENT.BUTTON')}
          </Button>
        </Box>
      </DialogWrapper>
    </>
  );
}